import type { ReactNode } from 'react';
import { createContext, useEffect, useMemo, useState } from 'react';
import { useDefinedContext } from '@shared/hooks/useDefinedContext';

interface PlaidContextProviderProps {
  children: ReactNode;
}

export interface PlaidContextState {
  linkToken: string | null;
  setLinkToken: (token: string) => void;
}

export const PlaidContext = createContext<PlaidContextState | null>(null);
PlaidContext.displayName = 'Plaid';

export const usePlaidContext = () => useDefinedContext(PlaidContext);

export const PLAID_LINK_TOKEN_KEY = 'plaid-link-token';

export const PlaidContextProvider = ({
  children,
}: PlaidContextProviderProps) => {
  const [linkToken, _setLinkToken] = useState<string | null>(null);

  useEffect(() => {
    _setLinkToken(localStorage.getItem(PLAID_LINK_TOKEN_KEY));
  }, []);

  const value = useMemo<PlaidContextState>(
    () => ({
      linkToken,
      setLinkToken: (token: string) => {
        localStorage.setItem(PLAID_LINK_TOKEN_KEY, token);
        _setLinkToken(token);
      },
    }),
    [linkToken, _setLinkToken],
  );

  return (
    <PlaidContext.Provider value={value}>{children}</PlaidContext.Provider>
  );
};
